import { ManageYourTeamPage } from '@weirgroup/cde-iam-accessmanagement-app'
import { useEffect } from 'react'
import { history } from '../../utils/history.util'
import "./styles.scss"
import { useDarkMode } from '../../hooks/use-darkmode'
import { useAnalyticsEvent } from '../../hooks/useAnalyticsEvent'
import { APP_NAME } from '../../constants/app-name'
// import store from '../../redux/store'
export const ManageYourTeam = (props: any) => {
    const {darkMode} = useDarkMode()
    const logAnalyticsEvent = useAnalyticsEvent()
    
    useEffect(() => {
        logAnalyticsEvent('user_viewed_manage_team_page', { description: 'User viewed manage team page' });
    }, []);
    return (
        <div className='manage-your-team-container'>
        <ManageYourTeamPage
            // store={store}
            darkMode={darkMode}
            history={history}
            handleProgressAction
            appName={APP_NAME}
            applicationID={process.env.REACT_APP_MSAL_CLIENT_ID}
            sourceSystemName={'IamServices'}
        />
        </div>
    )
}
